import {
  GET_CHARGES,
  CHARGE_ERROR,
  DELETE_CHARGE,
  ADD_CHARGE,
  UPDATE_CHARGE,
} from 'src/actions/types'

const initialState = {
  charges: {
    data: [],
    current_page: 1,
  },
  filters: {},
  loading: true,
  error: {},
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
  const { type, payload } = action

  switch (type) {
    case GET_CHARGES:
      return {
        ...state,
        charges: payload.data,
        filters: payload.filters,
        loading: false,
      }
    case ADD_CHARGE:
      return {
        ...state,
        charges: { data: [payload, ...state.charges.data] },
        loading: false,
      }
    case UPDATE_CHARGE: {
      let index = state.charges.data.findIndex((concept) => concept.id === payload.id)
      state.charges.data[index] = { ...state.charges.data[index], ...payload }
      return {
        ...state,
        charges: { data: [...state.charges.data], ...state.charges },
        loading: false,
      }
    }
    case DELETE_CHARGE:
      return {
        ...state,
        charges: { data: state.charges.data.filter((concept) => concept.id !== payload) },
        loading: false,
      }
    case CHARGE_ERROR:
      return {
        ...state,
        error: payload,
        loading: false,
      }
    default:
      return state
  }
}
